import { PluginManifest } from "./types";
import { headacheQuestionnaireModule } from "./headache-questionnaire/manifest";

/**
 * Every module package known to the app. Add a module's manifest here once; the
 * host composes only those whose id is enabled for the deployment.
 */
export const ALL_MANIFESTS: PluginManifest[] = [headacheQuestionnaireModule];
